"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_fetch_1 = require("@biw/client-fetch");
var action_types_1 = require("./action-types");
exports.fetchLocaleBundle = function (code, name) {
    if (code === void 0) { code = ''; }
    return client_fetch_1.clientFetch({
        url: "/translations/" + name + (code ? "?locale=" + code : ''),
        type: action_types_1.LOCALE_BUNDLE
    });
};
exports.fetchNativeLocaleBundle = function (code, name) {
    if (code === void 0) { code = ''; }
    return client_fetch_1.clientFetch({
        url: "/translations/" + name + (code ? "?locale=" + code : ''),
        type: action_types_1.LOCALE_BUNDLE
    });
};
exports.postUserLocale = function (code) { return client_fetch_1.clientFetch({
    url: '/api/v1.0/user/locale',
    method: 'post',
    body: { locale: code },
    type: action_types_1.USER_LOCALE
}); };
//# sourceMappingURL=api.js.map